import { atom } from "recoil"

export const questionnaireAnswerCsvDataRequestIdState = atom<number>({
  key: "atoms/csvData/questionnaireAnswerCsvDataRequestIdState",
  default: 0,
})
